import React from 'react';

/*
    - ihoDesignSystem
*/
import { Box, Grid, RadioButton, Select, TextField, Typography } from '@iho-design-system/Loader';

const Transfer = ({ hasFreeTransferResult, airplanCompaniesResult, trainLinesResult, requestType, selectedService, sendRequestStatusProps, transferProps }) => {

    /*
        - defaultData
    */
    const [transferType, setTransferType] = React.useState('');
    const [transferOrigin, setTransferOrigin] = React.useState('');
    const [transferCompany, setTransferCompany] = React.useState('');
    const [transferTime, setTransferTime] = React.useState('');
    const [transferVoucher, setTransferVoucher] = React.useState('');

    /*
        - handleTransferType
    */
    const handleTransferType = (value) => {
        setTransferType(value);
    }

    React.useEffect(() => {
        let sendRequestStatus = false;
        if (transferType !== '' && transferOrigin !== '' && transferCompany !== '' && transferTime !== '' && transferVoucher !== '') {
            sendRequestStatus = true;
            let helper = {};
            helper.transferType = transferType;
            helper.transferOrigin = transferOrigin;
            helper.transferCompany = transferCompany;
            helper.transferTime = transferTime;
            helper.transferVoucher = transferVoucher;
            transferProps(helper);
        }
        sendRequestStatusProps(sendRequestStatus);
    }, [transferType, transferOrigin, transferCompany, transferTime, transferVoucher]);

    /*
        - cancelProgress
    */
    React.useEffect(() => {
        if (selectedService === 'cancel') {
            sendRequestStatusProps(true);
        }
    }, []);

    React.useEffect(() => {
        setTransferType('');
        setTransferOrigin('');
        setTransferCompany('');
        setTransferTime('');
        setTransferVoucher('');
    }, [requestType]);

    return (

        <React.Fragment>

            {requestType.split(',')[1] === 'transfer' && requestType.split(',')[3] === 'selectReserve' && requestType.split(',')[4] === undefined &&
                <Box
                    className={`w-100 my-lg mb-0 border-solid-top border-medium`}>
                    <Typography
                        className={`py-md`}
                        component='h5'>
                        اطلاعات ترنسفر
                    </Typography>
                    {hasFreeTransferResult &&
                        <Box
                            className={`w-100`}
                            ms={{
                                maxHeight: '268px',
                                overflowY: 'auto',
                                overflowX: 'hidden',
                                opacity: '0',
                                animation: 'reserveAnimation 0.5s linear',
                                animationDelay: '1s',
                                animationFillMode: 'forwards',
                                '&::-webkit-scrollbar': {
                                    width: '4px',
                                    opacity: '0'
                                },
                                '&::-webkit-scrollbar-thumb': {
                                    backgroundColor: 'var(--blue-medium)',
                                    borderRadius: 'var(--sizing-md)'
                                }
                            }}>
                            <Box
                                className={`w-100`}>
                                <Box
                                    className={`my-sm mt-0 rounded-sm`}
                                    ms={{
                                        backgroundColor: 'var(--gray-medium)'
                                    }}>
                                    <Grid>
                                        <Grid.Wrapper>
                                            <Grid.Item
                                                size='col-6'>
                                                <RadioButton
                                                    onChange={handleTransferType}
                                                    label='فرودگاه'
                                                    value='فرودگاه'
                                                    ms={{
                                                        verticalAlign: 'middle'
                                                    }} />
                                            </Grid.Item>
                                            <Grid.Item
                                                size='col-6'>
                                                <RadioButton
                                                    onChange={handleTransferType}
                                                    label='راه‌آهن'
                                                    value='راه‌آهن'
                                                    ms={{
                                                        verticalAlign: 'middle'
                                                    }} />
                                            </Grid.Item>
                                            {transferType === 'فرودگاه' &&
                                                <React.Fragment>
                                                    <Grid.Item
                                                        size='col-6'>
                                                        <TextField
                                                            onChange={setTransferOrigin}
                                                            placeholder='مبدا'
                                                            value={transferOrigin} />
                                                    </Grid.Item>
                                                    <Grid.Item
                                                        size='col-6'>
                                                        <Select
                                                            onChange={setTransferCompany}
                                                            placeholder='شرکت هواپیمایی'>
                                                            {airplanCompaniesResult.map((obj, index) => {
                                                                return (
                                                                    <Select.Item
                                                                        key={index}
                                                                        value={obj.title}>
                                                                        {obj.title}
                                                                    </Select.Item>
                                                                )
                                                            })}
                                                        </Select>
                                                    </Grid.Item>
                                                    <Grid.Item
                                                        className={`align-self-center`}
                                                        size='col-6'>
                                                        <TextField
                                                            onChange={setTransferTime}
                                                            placeholder='ساعت پرواز'
                                                            value={transferTime} />
                                                    </Grid.Item>
                                                    <Grid.Item
                                                        className={`align-self-center`}
                                                        size='col-6'>
                                                        <TextField
                                                            onChange={setTransferVoucher}
                                                            placeholder='شماره پرواز'
                                                            value={transferVoucher} />
                                                    </Grid.Item>
                                                </React.Fragment>
                                            }
                                            {transferType === 'راه‌آهن' &&
                                                <React.Fragment>
                                                    <Grid.Item
                                                        size='col-6'>
                                                        <TextField
                                                            onChange={setTransferOrigin}
                                                            placeholder='مبدا'
                                                            value={transferOrigin} />
                                                    </Grid.Item>
                                                    <Grid.Item
                                                        size='col-6'>
                                                        <Select
                                                            onChange={setTransferCompany}
                                                            placeholder='نام قطار'>
                                                            {trainLinesResult.map((obj, index) => {
                                                                return (
                                                                    <Select.Item
                                                                        key={index}
                                                                        value={obj.title}>
                                                                        {obj.title}
                                                                    </Select.Item>
                                                                )
                                                            })}
                                                        </Select>
                                                    </Grid.Item>
                                                    <Grid.Item
                                                        className={`align-self-center`}
                                                        size='col-6'>
                                                        <TextField
                                                            onChange={setTransferTime}
                                                            placeholder='ساعت رسیدن'
                                                            value={transferTime} />
                                                    </Grid.Item>
                                                    <Grid.Item
                                                        className={`align-self-center`}
                                                        size='col-6'>
                                                        <TextField
                                                            onChange={setTransferVoucher}
                                                            placeholder='شماره قطار'
                                                            value={transferVoucher} />
                                                    </Grid.Item>
                                                </React.Fragment>
                                            }
                                        </Grid.Wrapper>
                                    </Grid>
                                </Box>
                            </Box>
                        </Box>
                    }
                    {!hasFreeTransferResult &&
                        <React.Fragment>
                            <Box
                                className={`w-100`}>
                                <Box
                                    className={`rounded-sm`}
                                    ms={{
                                        backgroundColor: 'var(--gray-medium)'
                                    }}>
                                    <Grid.Item
                                        size='col-12'>
                                        <Typography
                                            ms={{
                                                lineHeight: '30px',
                                                fontWeight: 'bold'
                                            }}>
                                            این هتل قابلیت ترنسفر ندارد.
                                        </Typography>
                                    </Grid.Item>
                                </Box>
                            </Box>
                        </React.Fragment>
                    }
                </Box>
            }

        </React.Fragment>

    );

}

export default Transfer;